import style from './AssetViewWithTracking.module.css';

const fieldLabels = {
  finished: 'Completed',
  allCorrect: 'All answers correct',
  givenAnswers: 'Submitted answers',
  correctAnswers: 'Correct answers',
  uidAnswers: 'Answer identifiers',
  uidClicks: 'Selected options',
  uidCorrectClicks: 'Correct options'
};

const labelFor = (key) => {
  if (Object.prototype.hasOwnProperty.call(fieldLabels, key)) return fieldLabels[key];
  const words = key
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim();
  return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
};

const rowsFor = (data, path = []) => Object.entries(data).flatMap(([key, value]) => {
  const labels = [...path, Array.isArray(data) ? `Item ${Number(key) + 1}` : labelFor(key)];
  const hasNestedValues = Array.isArray(value) && value.some(item => item !== null && typeof item === 'object');
  if (value !== null && typeof value === 'object' && Object.keys(value).length > 0 && (!Array.isArray(value) || hasNestedValues)) {
    return rowsFor(value, labels);
  }
  return [{ labels, value }];
});

const SubmittedValue = ({ value }) => {
  if (value === null || (typeof value === 'object' && Object.keys(value).length === 0)) {
    return <span>{JSON.stringify(value)}</span>;
  }
  if (Array.isArray(value)) {
    return <ul className={style.answerList}>{value.map((item, index) => <li key={index}><SubmittedValue value={item} /></li>)}</ul>;
  }
  return <span>{String(value)}</span>;
};

const SubmittedData = ({ data }) => {
  const rows = rowsFor(data);
  if (!rows.length) return <p className={style.emptyValue}>No details were included in this submission.</p>;
  return (
    <div className={style.dataScroll} role="region" aria-label="Submitted values" tabIndex={0}>
      <table className={style.dataTable} aria-label="Submission details">
        <tbody>
          {rows.map(({ labels, value }, index) => (
            <tr key={index}>
              <th scope="row">
                {labels.length > 1 && <span className={style.fieldGroup}>{labels.slice(0, -1).join(' / ')}</span>}
                {labels[labels.length - 1]}
              </th>
              <td><SubmittedValue value={value} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubmittedData;
